// Moteur de rendu / géométrie price-eat — PARITÉ player.
// Porté de F:\SIGNAGE-WEBAPP\src\overlay\OverlayLayer.ts (réplique de PriceDisplayService.java).
//
// Le player positionne en pixels absolus : left = position_x × 38 (idem Y), sur l'écran du device.
// La largeur d'écran de RÉFÉRENCE dépend du design des prix (déduite du maxX) :
//   - design FHD  (positions ≤ ~50 en X)  -> écran 1920  (ex. l'Escale : device FHD, vidéo 4K)
//   - design 4K   (positions jusqu'à ~100) -> écran 3840  (ex. GLD : vrai mur 2×2 / écran 4K)
// On mappe la référence à la largeur de l'aperçu (scale = stageW / designW).
// Option CROP (4K uniquement) : zoom sur une dalle 1920×1080 (TL/TR/BL/BR) du mur.

export const VW_FACTOR = 38;

export const num = (v, d = 0) => {
    const n = parseFloat(v);
    return isFinite(n) ? n : d;
};

/**
 * @param stageW/stageH dimensions px de l'aperçu
 * @param designW largeur écran de référence (1920 ou 3840), déduite du maxX des prix
 * @param crop true pour zoomer sur une dalle (4K seulement)
 * @param quadrant 0..3 (TL,TR,BL,BR)
 */
export function metrics({ stageW, stageH, designW = 1920, crop = false, quadrant = 0 }) {
    const worldW = designW;
    const worldH = designW * 9 / 16;
    if (crop && designW >= 3840) {
        const tileW = worldW / 2, tileH = worldH / 2; // 1920 × 1080
        const col = quadrant % 2, row = Math.floor(quadrant / 2);
        const scale = stageW / tileW;
        return { crop: true, W: stageW, H: stageH, scale, fscale: scale, ox: col * tileW, oy: row * tileH, tileW, tileH, quadrant, col, row };
    }
    const scale = stageW / worldW;
    return { crop: false, W: stageW, H: stageH, scale, fscale: scale };
}

// position stockée -> coordonnées écran (px) dans l'aperçu
export function posToScreen(m, x, y) {
    const gx = x * VW_FACTOR, gy = y * VW_FACTOR;
    if (m.crop) return [(gx - m.ox) * m.scale, (gy - m.oy) * m.scale];
    return [gx * m.scale, gy * m.scale];
}

// coordonnées écran (px, aperçu) -> position stockée
export function screenToPos(m, sx, sy) {
    const gx = m.crop ? sx / m.scale + m.ox : sx / m.scale;
    const gy = m.crop ? sy / m.scale + m.oy : sy / m.scale;
    return [gx / VW_FACTOR, gy / VW_FACTOR];
}

// En crop : masque les prix hors de la dalle affichée. Sinon tout est visible.
export function inView(m, x, y) {
    if (!m.crop) return true;
    const gx = x * VW_FACTOR, gy = y * VW_FACTOR;
    return gx >= m.ox && gx < m.ox + m.tileW && gy >= m.oy && gy < m.oy + m.tileH;
}

// zoom CSS de la vidéo 4K sur la dalle (scale 2)
export function quadrantVideoTransform(quadrant) {
    const origins = ['0% 0%', '100% 0%', '0% 100%', '100% 100%'];
    return { transform: 'scale(2)', transformOrigin: origins[quadrant] || '0% 0%' };
}

// HTML interne d'un prix (entier + décimales/€ en spans de tailles distinctes)
export function priceInnerHTML(price, fscale, { euro = true, taille = 1, fontSize = 24 } = {}) {
    const intSize = (fontSize / 2) * fscale;
    const decSize = (fontSize * taille / 2) * fscale;
    const s = (isFinite(+price) ? +price : 0).toFixed(2);
    const i = s.indexOf('.');
    const e = euro ? '€' : '';
    if (i >= 0) {
        return `<span style="font-size:${intSize}px">${s.slice(0, i)}</span>` +
            `<span style="font-size:${decSize}px">${s.slice(i)}${e}</span>`;
    }
    return `<span style="font-size:${intSize}px">${s}${e}</span>`;
}
